const getApiBaseUrl = () => {
  const hostname = window.location.hostname || '';

  if (hostname === 'facturador.orderly.mx') {
    return 'https://apifacturador.orderly.mx';
  }

  if (hostname === 'demo.facturador.site' || hostname === 'localhost') {
    return 'http://api.facturador.site';
  }

  return 'https://apifacturador.inwork.site';
};

const resolveDomain = (host) => {
  if (host === 'facturador.orderly.mx') {
    return 'orderly';
  }

  if (host === 'demo.facturador.site' || host === 'localhost') {
    return 'demo';
  }

  const parts = (host || '').split('.');
  if (parts.length >= 2 && parts[0] === 'facturador') {
    return parts[1];
  }

  return parts[0] || 'orderly';
};

const showMessage = (message, isError = false) => {
  const app = document.getElementById('app');
  if (!app) {
    return;
  }

  app.innerHTML = '<div style="font-family: Arial, sans-serif; padding: 24px; text-align: center; color: '
    + (isError ? '#b00020' : '#1f2937')
    + ';">' + message + '</div>';
};

export const handlePublicDownloadRoute = async () => {
  const match = window.location.pathname.match(/^\/download\/([^\/]+)\/(xml|pdf)\/?$/i);
  if (!match) {
    return false;
  }

  const uuid = decodeURIComponent(match[1] || '').trim();
  const fileType = (match[2] || '').toLowerCase();
  const endpoint = fileType === 'xml' ? '/download/public-xml' : '/download/public-pdf';

  showMessage('Resolviendo archivo, espera un momento...');

  try {
    const response = await fetch(getApiBaseUrl() + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        domain: resolveDomain(window.location.hostname || ''),
        uuid: uuid
      })
    });

    const data = await response.json();

    if (data && data.type === 'success' && data.data) {
      window.location.replace(data.data);
      return true;
    }

    showMessage('No se pudo descargar el archivo solicitado.', true);
    return true;
  } catch (error) {
    showMessage('No se pudo descargar el archivo solicitado.', true);
    // eslint-disable-next-line no-console
    console.error(error);
    return true;
  }
};
